// Approximation of the standard normal cumulative distribution function (CDF)
export function normalCDF(z: number): number {
  // Constants for the Abramowitz and Stegun approximation
  const t = 1 / (1 + 0.2316419 * Math.abs(z));
  const d = 0.3989423 * Math.exp((-z * z) / 2);
  const prob = d * t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.330274))));
  if (z > 0) {
    return 1 - prob;
  }
  return prob;
}
